// Content type enum
export enum ContentType {
  FULL_REPORT = 'FULL_REPORT',
  SMART_MONEY = 'SMART_MONEY',
  LORE = 'LORE',
}

// Tweet status enum
export enum TweetStatus {
  PENDING = 'PENDING',
  PUBLISHED = 'PUBLISHED',
}

// Tweet content DTO
export interface TweetContentDto {
  _id: string;
  id: string;
  tokenAddress: string;
  contentType: ContentType;
  status: TweetStatus;
  contents: string[];
  communityId: string | null;
  tweetId: string | null;
  publishedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

// Generate tweet request
export interface GenerateTweetRequest {
  contentType: ContentType;
}

// Update tweet request
export interface UpdateTweetRequest {
  contents: string[];
}

// API response wrapper
export interface ApiResponse<T> {
  data: T;
  message?: string;
}
